import React, {
  FC,
  HTMLAttributes,
  useState,
  type PropsWithChildren
} from 'react'
import Button from '../button'
import DownloadPopup from '../resource-centre/download-popup'
import { useWatchCourseForm } from '../../hooks/use-watch-course-form'

interface CoursePopupButtonProps {
  to: string;
}

export const CoursePopupButton: FC<PropsWithChildren<CoursePopupButtonProps>> = (
  props
) => {
  const [open, setOpen] = useState(false)
  const { to, ...rest } = props

  const onClick: HTMLAttributes<HTMLButtonElement>['onClick'] = (e) => {
    e.preventDefault()
    setOpen(true)
  }

  return (
    <>
      <Button {...rest} to="#" iconLeft="playCircle" onClick={onClick} />
      {open && (
        <DownloadPopup
          title="To get access to this video, please enter your email address."
          filePath={to}
          handlePopupClose={() => setOpen(false)}
          useForm={useWatchCourseForm}
        />
      )}
    </>
  )
}
